import React from 'react';
import clsx from 'clsx';
import { DivPropsWithoutRef } from '../../common';

export interface DropdownMenuDividerProps
  extends DivPropsWithoutRef {
}

export const DropdownMenuDivider: React.FC<DropdownMenuDividerProps> = ({
  className,
  ...props
}) => {
  return (
    <div className={clsx('hse-DropdownMenuDivider', className)} {...props}>
      <div className="hse-DropdownMenuDivider__line" />
    </div>
  );
};
